import styled from 'styled-components/macro'

const SearchResultSelectedFilters = styled.div`
  span > span {
    background-color: #003399;
    color: white;
    i {
      display: none;
    }
  }
`
export default SearchResultSelectedFilters
